(() => {
  const muteYouTubeTemplates = (root = document) => {
    root.querySelectorAll('template').forEach((template) => {
      template.content.querySelectorAll('iframe.js-youtube').forEach((iframe) => {
        try {
          const url = new URL(iframe.src);
          const hostname = url.hostname.toLowerCase();

          if (hostname !== 'www.youtube.com' && hostname !== 'www.youtube-nocookie.com') return;
          if (url.searchParams.get('mute') === '1') return;

          url.searchParams.set('mute', '1');
          iframe.src = url.toString();
        } catch (error) {
          // Preserve Shopify's original YouTube embed if its URL cannot be parsed.
        }
      });
    });
  };

  muteYouTubeTemplates();
  document.addEventListener('shopify:section:load', (event) => muteYouTubeTemplates(event.target));
})();
